<template>
  <div class="animated fadeIn">
    <b-row class="my-3">
      <b-col>
        <h4 class="text-center text-primary">
          <i class="fa fa-check-square text-primary mr-2"></i>
          Nueva Lista de Distribución
        </h4>
      </b-col>
    </b-row>
    <b-row class="my-2">
      <b-card class="w-100">
        <b-form @submit.prevent="store" autocomplete="off">
          <b-row class="pb-2">
            <b-col sm="12" md="12">
              <b-form-group
                :horizontal="true"
                label="<strong>Nombre *</strong>"
                label-cols="2"
                label-for="name"
              >
                <b-form-input
                  type="text"
                  id="name"
                  placeholder="Nombre"
                  v-model="distributionList.name"
                  autocomplete="new-name">
                </b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row class="pb-2">
            <b-col sm="12" md="12" lg="4">
              <router-link to="/communications/distribution-list/search">
                <b-card
                  :class="{ 'bg-light': memberSearchCount === 0, 'bg-primary': memberSearchCount > 0 }"
                  class="text-center align-center py-5"
                  @click="handleSearchCardClick">
                    <h5 :style="{ color: memberSearchCount > 0 ? 'white' : '' }"  class="card-title mb-0">Socios/No Socios</h5>
                    <p v-if="memberSearchCount > 0" :style="{ color: memberSearchCount > 0 ? 'white' : '' }">
                      {{ memberSearchCount }} Socios de {{ totalMembers }}
                    </p>
                  <p v-else>Búsqueda Socios</p>
                </b-card>
              </router-link>
            </b-col>
            <b-col sm="12" md="12" lg="4">
              <router-link to="/communications/distribution-list/list-contact">
                <b-card
                  :class="{ 'bg-light': numberOfSelectedContacts === 0, 'bg-primary': numberOfSelectedContacts > 0 }"
                  class="text-center align-center py-5"
                  @click="handleContactsCardClick">
                    <h5 :style="{ color: numberOfSelectedContacts > 0 ? 'white' : '' }" class="card-title mb-0">Contactos</h5>
                    <p v-if="numberOfSelectedContacts > 0" :style="{ color: numberOfSelectedContacts > 0 ? 'white' : '' }">
                      {{ numberOfSelectedContacts }} Contactos de {{ totalContacts }}
                    </p>
                    <p v-else>Seleccion manual</p>
                </b-card>
              </router-link>
            </b-col>
            <b-col sm="12" md="12" lg="4">
                <b-card  :class="{'text-center': true,'text-primary': true,'align-center': true,'py-5': true,'bg-light': !cardStates.fileSelected,'bg-primary': cardStates.fileSelected }" style="cursor: pointer" @click="handleFileUploadClick">
                  <h5 class="card-title mb-0" :style="{ color: cardStates.fileSelected ? 'white' : '' }">Contactos</h5>
                  <p :style="{ color: cardStates.fileSelected ? 'white' : '' }">Importar fichero</p>
                  <input
                    ref="fileInput"
                    type="file"
                    style="display: none;"
                    @change="handleFileInputChange"
                  />
                </b-card>
              <a href="#" class="float-right mb-2" @click="downloadExcelFile">Descargar plantilla de fichero</a>
            </b-col>
          </b-row>
          <b-row>
            <div class="col float-left">
              <button
                type="submit"
                class="btn btn-brand btn-primary btn-lg pull-right"
                :disabled="!generalValidate()"
                v-if="mixinCheckPermission('DISTRIBUTION_LIST_NEW')">
                Guardar
              </button>
            </div>
          </b-row>
        </b-form>
      </b-card>
    </b-row>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect';
import locationContactForm from "@/components/location/LocationContactForm.vue";
import { mapGetters } from 'vuex';

export default {
  name: 'addDistributionList',
  components: {
    locationContactForm,
    Multiselect,
  },
  computed: {
    ...mapGetters({
      listContactResponse: 'getListContactResponse',
      listMemberSearchResponse: 'getListMemberSearchResponse'
    })
  },
  mounted() {
    this.selectedCard = localStorage.getItem('selectedCard') || null;
    if (this.selectedCard === 'file') {
      this.cardStates.file = true;
    } else if (this.selectedCard === 'search') {
      this.cardStates.search = true;
    } else if (this.selectedCard === 'contacts') {
      this.cardStates.contacts = true;
    }
    localStorage.removeItem('selectedCard');
    this.$eventHub.$emit('captureMenu', this.topmenu);
    const storedResponse = this.listContactResponse;
    if (storedResponse) {
      this.numberOfSelectedContacts = storedResponse.selectedCount || 0;
      this.totalContacts = storedResponse.totalRecords || 0;
      this.selectedContactUUIDs = storedResponse.selectedIds;
    }

    const storedSearchMemberResponse = this.listMemberSearchResponse;
    if (storedSearchMemberResponse){
      this.memberSearchCount = storedSearchMemberResponse.selectedCount || 0;
      this.totalMembers = storedSearchMemberResponse.totalRecords || 0;
      this.distributionList.search.search_fields = storedSearchMemberResponse.searchFields;
      this.distributionList.search.fieldsList = storedSearchMemberResponse.fieldsList;
      this.distributionList.search.selectedEntity = storedSearchMemberResponse.selectedEntity;
    }
  },
  data: function () {
    return {
      topmenu: [
        {name: 'Volver', path: '/communications/distribution-list/list', brand: 'fa fa-arrow-left'},
      ],
      numberOfSelectedContacts: 0,
      totalContacts: 0,
      memberSearchCount: 0,
      totalMembers: 0,
      selectedContactUUIDs: [],
      distributions: [],
      distributionList: {
        name: null,
        search: {
          search_fields: [],
          selectedEntity: '',
          fieldsList: []
        }
      },
      selectedCard: null,
      visible: false,
      cardStates: {
        contacts: false,
        search: false,
        file: false,
        fileSelected: false
      }
    }
  },
  methods: {
    async downloadExcelFile() {
      try {
        // Replace 'file.xlsx' with the actual file name in your public folder
        const fileName = 'contacts.csv';

        const response = await fetch(`/${fileName}`);

        const fileBlob = await response.blob();

        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(fileBlob);
        link.download = fileName;

        link.click();
      } catch (error) {
        console.error('Error downloading file:', error);
      }
    },
    store() {
      if (!this.distributionList.name) {
        return;
      }

      let formData = new FormData();

      formData.append('name', this.distributionList.name);
      if (this.selectedContactUUIDs && this.selectedContactUUIDs.length > 0) {
        formData.append('contacts', JSON.stringify(this.selectedContactUUIDs));
      } else {
        formData.append('contacts', null);
      }

      if (this.distributionList.search && Object.keys(this.distributionList.search.search_fields).length > 0) {
        formData.append('search', JSON.stringify(this.distributionList.search));
      } else {
        formData.append('search', null);
      }

      const fileFormData = this.prepareFileFormData();
      if (fileFormData) {
        formData.append('file', fileFormData.get('file'));
      }

      let headers = {
        'Content-Type': 'multipart/form-data',
      };

      this.submitData(formData, headers);

    },
    prepareFileFormData() {
      const fileInput = this.$refs.fileInput;
      const file = fileInput.files[0];

      if (file){
        const formData = new FormData();
        formData.append('file', file);

        return formData;
      }else
      {
        return null;
      }
    },
    submitData(data, headers) {
      this.$_loadingMixin_showLoading();
      axios.post('distribution-list', data, {
        headers: headers
      })
        .then((response) => {
          this.$_loadingMixin_hideLoading();
          if (response.status === 201) {
            this.$_notificationMixin_success('Operación Completada', 'Realizado con éxito');
            this.$store.dispatch('clearListContactResponse');
            this.$store.dispatch('clearContactsResponse');
            this.$store.dispatch('clearSearchMemberResponse');
            localStorage.removeItem('selectedCard');
            this.$router.push({ path: '/communications/distribution-list/list' });
          }
        })
        .catch((error) => {
          this.$_loadingMixin_hideLoading();
          this.showApiError(error.response);
        });
    },
    generalValidate() {
      if (!this.distributionList.name) {
        return false;
      } else {
        return true;
      }
    },
    showApiError(response) {
      if (response.status === 400) {
        this.$_notificationMixin_error('Error al guardar la lista de distribución', 'Algo salió mal');
      }
    },
    handleFileUploadClick() {
      this.selectedCard = 'file';
      localStorage.setItem('selectedCard', this.selectedCard);
      this.cardStates.file = true;
      this.cardStates.contacts = false;
      this.cardStates.search = false;
      this.$refs.fileInput.click();
    },
    handleSearchCardClick() {
      this.selectedCard = 'search';
      localStorage.setItem('selectedCard', this.selectedCard);
      this.cardStates.search = true;
      this.cardStates.contacts = false;
      this.cardStates.file = false;
    },
    handleContactsCardClick() {
      this.selectedCard = 'contacts';
      localStorage.setItem('selectedCard', this.selectedCard);
      this.cardStates.contacts = true;
      this.cardStates.search = false;
      this.cardStates.file = false;
    },
    handleFileInputChange(event) {
      if (event.target.files && event.target.files.length > 0) {
        this.cardStates.fileSelected = true;
      } else {
        this.cardStates.fileSelected = false;
      }
    },
  }
}
</script>
<style>
.disabled-card {
  opacity: 0.6;
}
</style>
